import Box from "@mui/material/Box";
import { FC, ReactNode } from "react";
import { StyledFormControl } from "./styled";

type FieldContainerType = {
  className?: string;
  children: ReactNode;
  disabled?: boolean;
};

const FieldContainer: FC<FieldContainerType> = (props) => (
  <Box
    display="flex"
    flexDirection="column"
    width="100%"
    className={props.className}
  >
    <StyledFormControl disabled={props.disabled}>
      {props.children}
    </StyledFormControl>
  </Box>
);

export default FieldContainer;
